module.exports = __webpack_public_path__ + "img/harga-special.e5630720.svg";